import { faClose } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Form, Input, Modal } from "antd"
import { emailRegex } from "../../util/regex";
import { useState } from "react";
import Spinner from "../spinner";

export const ReportShare = ({visible, loading, close, sendReportOnEmail})=>{

    const [email, setEmail] = useState({value:'', err: ''});

    const handelEmail = (value)=>{
        if(!emailRegex.test(value)){
            setEmail({
                value: value,
                err: "Email is not valid"
            });
        }else{
            setEmail({
                value: value,
                err: ''
            });
        }
    };

    return(
        <Modal
            open={visible}
            width={600}
            footer={
                <div className="drawer-footer" style={{padding:'26px 40px', textAlign:'left', display:'flex', columnGap:'16px', marginTop:'-25px' }}>
                    <button  
                        onClick={()=>{sendReportOnEmail(email?.value)}}
                        disabled={loading || email?.err || email?.value?.length==0} 
                        className={(loading || email?.err || email?.value?.length==0) ? 'disabled-btn drawer-filled-btn' : 'drawer-filled-btn'} 
                    >
                        {loading? <Spinner/>: "Send"}
                    </button>
                    <button disabled={loading} className={loading? 'disabled-btn drawer-outlined-btn':'drawer-outlined-btn'} onClick={close}>
                        Cancel
                    </button>
                </div>
            }
            closable={false}
        >

            <div className='modal-header-title'  style={{height:'2.5em'}}>
                <span style={{letterSpacing:'0.2px'}}> Share with anyone </span>
                <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
            </div>

            <div className='modal-body'>
                
                    <Form>
                        <Form.Item>
                            <label>Add Email</label>
                            <Input 
                                type="email"
                                placeholder="Type email address..."
                                className="generic-input-control"
                                style={{width:'100%'}}
                                onChange={(e)=>handelEmail(e.target.value)}
                                value={email?.value}
                            />
                            <div className="subnote" style={{color:'red'}}>
                                {email?.err}
                            </div>
                        </Form.Item>
                    </Form>

            </div>


        </Modal>
    )
}